import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá, gostaria de receber atendimento.');
    window.open(`https://wa.me/5511989887113?text=${message}`, '_blank');
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Convertrex</h3>
            <p>
              {t('footer.description')}
            </p>
          </div>

          <div className="footer-section">
            <h4>{t('footer.quickLinks.title')}</h4>
            <ul>
              <li><a href="#home">{t('nav.home')}</a></li>
              <li><a href="#services">{t('nav.services')}</a></li>
              <li><a href="#about">{t('nav.about')}</a></li>
              <li><a href="#contact">{t('nav.contact')}</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t('footer.services.title')}</h4>
            <ul>
              <li>{t('services.items.web.title')}</li>
              <li>{t('services.items.ecommerce.title')}</li>
              <li>{t('services.items.traffic.title')}</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t('footer.contact.title')}</h4>
            <ul className="contact-info">
              <li>{t('contact.info.email.content')}</li>
              <li>{t('contact.info.phone.content')}</li>
            </ul>
            <div className="social-links">
              <a href="https://facebook.com/convertrex" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="https://instagram.com/convertrex_" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
              <a href="https://linkedin.com/company/convertrexbr" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <button onClick={handleWhatsAppClick} className="whatsapp-link">
                <FaWhatsapp />
              </button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-rights">
            <p>© 2025 Convertrex. {t('footer.rights')}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
